export enum PublicSessionState {
    closed = -1,
    suspended = 0,
    enabled = 1,
}
